import styled from 'styled-components';

export const LineInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ItemActions = styled.div`
  padding-top: 16px;
`;
